<template>
  <div class="modal-window bds086">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.FeedbackUploadFile.001","보드 내 최종결과물 추가") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="fileList"
        :sort-by="'date'"
        :single-select="singleSelect"
        show-select
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents"
      >
        <template v-slot:item.fileName="{ item }">
          <div
            class="txt ell-singleline large"
            :class="icoFile(item.fileExtDesc)"
          >
            {{ item.fileName }}
          </div>
        </template>

        <template v-slot:item.lastModUserName="{ item }">
          <div class="droplayer member relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="name">{{
                  item.lastModUserName
                }}</v-btn>
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="item.lastModUserId" />
              </div>
            </v-menu>
          </div>
        </template>

        <template slot="no-data">
          <div class="nodata-txt-noicon file">
            <v-alert :value="true">{{ $i18nUtil.trans("search.026","등록된 첨부파일이 없습니다.") }}</v-alert>
          </div>
        </template>
      </v-data-table>

      <div v-if="totalFileCount > 0" class="pagination">
        <v-pagination
          v-model="page"
          circle
          :length="(totalFileCount%itemsPerPage) === 0 ? (totalFileCount/itemsPerPage) : (totalFileCount/itemsPerPage)+1"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="registBoardFile">
        {{ $i18nUtil.trans("button.register","등록") }}
      </button>
    </footer>
  </div>
</template>
<script>
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
export default {
  components: {
    UserTooltip,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  watch: {
    page:function() {
      this.getBoardFile();
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      totalFileCount: 0,
      itemsPerPage: 5,
      singleSelect: false,
      selected: [],
      sort: "lastModDate",
      sortDesc: true,
      headers: [
        { text: this.$i18nUtil.trans("entity.file.filter.fileName","파일명"), value: "fileName", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdate","마지막 업데이트"), value: "lastModDate", align: "center" },
        { text: this.$i18nUtil.trans("entity.file.filter.lastUpdUserName","생성/수정자"), value: "lastModUserName", align: "center" },
      ],
      fileList: [],
    };
  },
  created() {
    this.getBoardFile();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    getBoardFile() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/paper/outputFileList",
        method: "post",
        params: {
          groupId: this.modalInfo.paperInfo.groupId,
          paperId: this.modalInfo.paperInfo.paperId,
          page: this.page - 1,
          itemsPerPage: this.itemsPerPage,
          sortBy: this.sort,
          sortDesc: this.sortDesc,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            this.pageCount = res.result.totalPageCount;
            this.fileList = res.result.fileList;
            this.totalFileCount = res.result.totalFileCount
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    icoFile(fileExtDesc) {
      if (fileExtDesc == "pdf") {
        return "ico-file-pdf";
      } else if (fileExtDesc == "jpg") {
        return "ico-file-jpg";
      } else if (fileExtDesc == "png") {
        return "ico-file-png";
      } else if (fileExtDesc == "img") {
        return "ico-file-img";
      } else if (fileExtDesc == "word") {
        return "ico-file-word";
      } else if (fileExtDesc == "gif") {
        return "ico-file-gif";
      } else if (fileExtDesc == "ppt") {
        return "ico-file-ppt";
      } else if (fileExtDesc == "excel") {
        return "ico-file-xlsx";
      } else if (fileExtDesc == "zip") {
        return "ico-file-zip";
      } else {
        return "ico-file-etc";
      }
    },
    registBoardFile() {
      EventBus.$emit("registFeedbackBoardFile", this.selected);
      this.$emit("close");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/FeedbackUploadFile.vue